import script from "./ImageEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEdit.vue?vue&type=script&setup=true&lang=ts"

import "./ImageEdit.vue?vue&type=style&index=0&id=7bfe2eb9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bfe2eb9"]])

export default __exports__